// Frontend mirror of the ELE subcontractor insurance minimums. The SERVER is the single
// source of truth: server/src/lib/insuranceMinimums.ts (PUBLIC_LIABILITY_MINIMUM 5,000,000
// / EMPLOYERS_LIABILITY_MINIMUM 10,000,000). These two figures are mirrored here by hand
// only because the SPA build cannot import a server module; if the server figures change,
// update them here too. Used by the public subcontractor onboarding page's insurance note.
export const PUBLIC_LIABILITY_MINIMUM = 5_000_000;
export const EMPLOYERS_LIABILITY_MINIMUM = 10_000_000;

export function poundsMinimum(amount: number): string {
  return `£${amount.toLocaleString("en-GB")}`;
}
